import {ErrorStateMatcher} from '@angular/material/core';
import {UntypedFormControl, FormGroupDirective, NgForm} from '@angular/forms';

export class CustomFieldErrorMatcher implements ErrorStateMatcher {
  constructor(private customControl?: UntypedFormControl,
              private isSubmitted?: any,
              private error?: boolean) {
  }

  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (!this.customControl) {
      return false;
    } else if (this.error !== undefined) {
      return this.customControl && (this.customControl.invalid || this.error) && this.isSubmitted;
    } else {
      return this.customControl && this.customControl.invalid && this.isSubmitted;
    }
  }
}
